import Cookies from "js-cookie"
import { AdminSidebar } from "@/components/admin/sidebar"
import { AdminHeader } from "@/components/admin/header"
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { Toaster } from "@/components/ui/sonner"
import { ErrorBoundary } from "@/components/error-boundary"
import { NavigationProgress } from "@/components/navigation-progress"
import { CommandPaletteProvider } from "@/components/command-palette"
import { PageTransition } from "@/components/page-transition"
import { TourProvider, useTour } from "@/components/ui/tour"
import { tours, ADMIN_TOUR_ID } from "@/config/tours"

function AdminLayoutContent() {
  const { start } = useTour()

  return (
    <>
      <NavigationProgress />
      <AdminSidebar onStartTour={() => start(ADMIN_TOUR_ID)} />
      <SidebarInset className="min-w-0 overflow-x-hidden">
        <AdminHeader />
        <main className="min-w-0 flex-1 overflow-x-hidden px-2 py-4 sm:px-4 md:py-6">
          <ErrorBoundary fallbackTitle="This page failed to load">
            <PageTransition />
          </ErrorBoundary>
        </main>
      </SidebarInset>
    </>
  )
}

export default function AdminLayout() {
  const defaultOpen = Cookies.get("sidebar_state") !== "false"

  return (
    <TourProvider tours={tours}>
      <SidebarProvider defaultOpen={defaultOpen}>
        <CommandPaletteProvider scope="admin">
          <AdminLayoutContent />
          <Toaster />
        </CommandPaletteProvider>
      </SidebarProvider>
    </TourProvider>
  )
}
